/**
  - fixes:
    - capability to compare two calculations at once.
 */



/**
MIT License

Copyright (c) 2024 Alex Lowe

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
 */

import 'antd/dist/reset.css';
import './global.css';
import React from 'react';
import './App.css';
import Calculator from './Calculator';
import { Paper } from '@mui/material';
import { Analytics } from "@vercel/analytics/react";
import { ConfigProvider } from 'antd';
import { ThemeProvider } from '@mui/material/styles';
import { muiTheme, antTheme } from './theme';  // Import both themes

function App() {
  return (
    <ThemeProvider theme={muiTheme}>
      <ConfigProvider theme={antTheme}>
        <Paper elevation={3} style={{ padding: '4px', margin: '4px', width: '99.6%', maxWidth: 'none' }}>
          <header className="App-header">
            <Calculator />
            <Analytics />
          </header>
        </Paper>
      </ConfigProvider>
    </ThemeProvider>
  );
}

export default App;